import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { GROUP_BY_UUID_RESOURCE } from "../group/use-group-by-uuid.query";
import { USER_APP_ROLE_RESOURCE } from "../user/use-user-app-role.query";
import { USER_SEARCH_OPERATION, USER_SEARCH_RESOURCE } from "../user/use-user-search.query";

export const RULE_DELETE_RESOURCE = "rule" as const;
export const RULE_DELETE_API_PATH = `/v1/${RULE_DELETE_RESOURCE}/{uuid}` as const;

export type RuleDeleteResponse =
  paths[typeof RULE_DELETE_API_PATH]["delete"]["responses"][200]["content"]["application/json"];

export const useRuleDeleteMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<RuleDeleteResponse, Error, { uuid: string; force?: boolean }>({
    mutationFn: async ({ uuid, force }) => {
      const response = await alphartisApiAxios.delete<RuleDeleteResponse>(`/v1/${RULE_DELETE_RESOURCE}/${uuid}`, {
        params: { force },
      });
      return response.data;
    },
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: [RULE_DELETE_RESOURCE],
        }),
        queryClient.invalidateQueries({
          queryKey: [GROUP_BY_UUID_RESOURCE],
        }),
        queryClient.invalidateQueries({
          queryKey: [USER_APP_ROLE_RESOURCE],
        }),
        queryClient.invalidateQueries({
          queryKey: [USER_SEARCH_RESOURCE, USER_SEARCH_OPERATION],
        }),
      ]);
    },
  });
};
